module.exports = __webpack_public_path__ + "img/coding-2.aad8089f.jpg";